<template>
	<div class="renewal">
		<div class="renewal-right" v-loading="loading">
			<div class="renewal-right__info">
				<div class="flex">
          <span>ICCID:</span>
					<el-input placeholder="请输入" v-model="params.iccid" size="normal">
					</el-input>
				</div>
				<div class="flex">
          <span>SN号:</span>
					<el-input placeholder="请输入" v-model="params.sn" size="normal">
					</el-input>
				</div>
				<el-button icon="el-icon-search" @click="handleCurrentChange(1)" size="small" type="primary">搜索</el-button>
				<el-button icon="el-icon-plus" size="small" class="template_btn" @click="onOpenForm(null)" type="primary">新增</el-button>
        <el-button icon="el-icon-upload2" type="primary" size="small" class="template_btn" @click="onOpenImport">导入续费资料</el-button>
        <el-button size="small" class="template_btn" icon="el-icon-s-tools" @click="onEditPrice">批量设置续费价格</el-button>
				<el-button size="small" class="template_btn" icon="el-icon-delete-solid" @click="batchDel">批量删除</el-button>
        <el-dropdown @command="onExport">
          <el-button class="template_btn ml-10" type="primary">
            导出<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="1">已设置价格卡</el-dropdown-item>
            <el-dropdown-item :command="2">未设置价格卡</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
			</div>
			<el-table :data="tableData" stripe size="small" @selection-change="selectionChange" style="width: 100%;padding-bottom:20px;border-bottom:1px solid #eee;" height="calc(100% - 130px)" border>
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column type="index" width="50" label="序号" />
				<el-table-column :prop="item.prop" align="center" :label="item.lable" :min-width="item.width || 110" v-for="(item, index) in tableHeader" :key="index"> </el-table-column>
				<el-table-column fixed="right" label="操作" width="140">
					<template slot-scope="scope">
						<span @click="onOpenForm(scope.row)" style="cursor: pointer;color: #4b88f6;margin-right:10px">修改 </span>
						<span @click="del(scope.row.id)" style="cursor: pointer;color: #ff0000b0;">删除 </span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				:current-page.sync="params.pageNumber"
				:page-sizes="[50, 100, 200, 300, 400]"
				:page-size.sync="params.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="params.totalNum"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
			/>
		</div>
    <!-- 新增/修改表单 -->
    <RenewalPriceForm 
      :visible.sync="formShow"
      :info="activeData"
      @onSuccess="handleCurrentChange(1)"
    />
    <!-- 设置续费价格 -->
    <EditRenewalPrice 
      :visible.sync="editPriceShow"
      @onSuccess="handleCurrentChange(1)"
    />
    <!-- 导入续费价格 -->
    <ImportRenewalInfo 
      :visible.sync="importPriceShow"
      @onSuccess="handleCurrentChange(1)"
    />
	</div>
</template>
<script>
import RenewalPriceForm from './components/RenewalPriceForm.vue';
import EditRenewalPrice from './components/EditRenewalPrice.vue';
import ImportRenewalInfo from './components/ImportRenewalInfo.vue';
export default {
  name:'renewalPriceManage',
	components: {
    RenewalPriceForm,
    EditRenewalPrice,
    ImportRenewalInfo
  },
	data() {
		return {
      editPriceShow:false,
      importPriceShow:false,
      formShow:false,
      activeData:null,
			errorList: [],
			loading: false,
      ids:[],
			tableData: [],
      params: {
				pageNumber: 1,
				pageSize: 50,
				totalNum: 0,
				iccid: '',
				simCard: '',
        sn:'',
        imei:'',
        deviceType:''
			},
			tableHeader: [
				// {
				// 	lable: 'SIM卡号',
				// 	prop: 'simCard',
				// },
				{
					lable: 'ICCID',
					prop: 'iccid',
				},
				{
					lable: 'SN号',
					prop: 'sn',
				},
				// {
				// 	lable: 'IMEI',
				// 	prop: 'imei',
				// },
				{
					lable: '设备型号',
					prop: 'deviceType',
				},
				{
					lable: '续费一年价格(元)',
					prop: 'oneYearPrice',
				},
				{
					lable: '续费两年价格(元)',
					prop: 'twoYearPrice',
				},
				// {
				// 	lable: '续费三年价格(元)',
				// 	prop: 'threeYearPrice',
				// },
				{
					lable: '备注',
					prop: 'remark',
				},
			],
		};
	},

	methods: {
    // 设置续费价格
    onEditPrice(){
      this.editPriceShow = true;
    },
    // 导入续费弹框
    onOpenImport(row){
      this.importPriceShow = true;
    },
    // 表单
    onOpenForm(row){
      this.activeData = row;
      this.formShow = true;
    },
		//搜索
    async search () {
			const { data, total } = await this.$API.pageExternalSimRenewPrice({
				deviceType: this.params.deviceType,
				iccid: this.params.iccid,
				simCard: this.params.simCard,
				sn: this.params.sn,
				imei: this.params.imei,
        pageNumber:this.params.pageNumber,
        pageSize:this.params.pageSize,
			});
      this.tableData = data;
      this.params.totalNum = total;
			//console.log(this.tableData)
		},
		//新增SN号关联
		addSnContacts() {
			this.addSnContactVisible = true;
		},
		closeDialog() {
			this.addSnContactVisible = false;
			this.search();
		},
		
		handleSizeChange(currentSize) {
			this.params.pageSize = currentSize;
			this.search();
		},
		handleCurrentChange(currentPage) {
			this.params.pageNumber = currentPage;
			this.search();
		},
		//删除
		del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(async () => {
        const res = await this.$API.deleteExternalSimRenewPrice({ ids:id });
        if (res.data.code !== 0) return this.$message.error(res.data.msg);
        this.$message.success(res.data.msg);
        this.search();
      }).catch(() => {});
		},
		// 批量选择
		selectionChange(rowList) {
			this.ids = rowList.map((row) => row.id).toString();
		},
		//批量删除
		async batchDel() {
      if(!this.ids.length) return this.$message.warning('请先选择数据');
      this.$confirm('是否确认批量删除当前选中?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(async () => {
        const res = await this.$API.deleteExternalSimRenewPrice({ ids: this.ids });
        if (res.data.code !== 0) return this.$message.error(res.data.msg);
        this.$message.success(res.data.msg);
        this.search();
      }).catch(() => {});
    },
    async onExport (type) {
      console.log(type);
      if(type === 2){
        return await this.$API.exportNotExternalSimRenewPrice();
      }
      await this.$API.exportExternalSimRenewPrice({ 
        deviceType: this.params.deviceType,
				iccid: this.params.iccid,
				simCard: this.params.simCard,
        sn: this.params.sn,
				imei: this.params.imei,
      });
    }
	},
	created() {
		this.search();
	},
};
</script>
<style lang="scss" scoped>
.renewal {
	display: flex;
	overflow: hidden;
	position: absolute;
	left: 20px;
	right: 20px;
	top: 20px;
	bottom: 20px;
  .flex{
    display: flex;
    width: 300px;
    align-items: center;
    font-size: 14px;
    color: #333;
    flex-direction: row;
    >.el-input{
      margin: 0 10px;
      flex: 1;
    }
  }
	.template_btn {
		float: right;
	}
	.update_btn {
		height: 34px;
		margin-left: 10px;
	}
	.renewal-left {
		width: 230px;
		padding: 20px;
		margin-right: 20px;
		background: #fff;
		display: flex;
		flex-direction: column;
	}
	.renewal-right {
		background: #fff;
		flex: 1;
		min-width: 900px;
		position: relative;
		padding: 10px;
		&__info {
			display: flex;
			justify-content: left;
			padding: 10px 0 20px 0;
			position: relative;
			> button {
				margin-left: 10px;
			}
			> .fr {
				position: absolute;
				right: 0;
				top: 2px;
				color: #333;
				font-size: 14px;
				> span {
					color: #f56c6c;
					display: inline-block;
					margin: 0 4px;
				}
				> button {
					margin-left: 10px;
				}
			}
      .ml-10{
        margin-left: 10px;
      }
			.el-input-group__prepend {
				padding: 0 5px;
			}
			.el-select {
				width: 115px;
				height: 32px;
			}
			/deep/ .el-input__inner {
				height: 34px;
			}
		}
	}
	.recharge_div {
		line-height: 34px;
		.el-col {
			margin-bottom: 10px;
			> span {
				color: #f56c6c;
				font-size: 16px;
			}
		}
	}
}
// .el-button{
//   height: 34px;
// }
</style>
